











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { log } from '@/log'
import { PaymentType } from '@/models/app-config/behavior/types'
import { CookieService } from '@/services/cookie'
import ExternalPaymentCallbackView from '@ajax/vue/components/organisms/external-payment/ExternalPaymentCallbackView.vue'
import { interaction, ValidateApiResponse } from '@ajax/vue/components/organisms/external-payment/model/interaction'
import { ViewModel, ViewModelBuilder } from '@ajax/vue/components/organisms/external-payment/model/view-model'

@Component({
  components: {
    ExternalPaymentCallbackView,
  },
})
export default class ExternalPaymentCallback extends Vue {
  @Prop({ required: true })
  paymentType: PaymentType

  @Prop({ required: true })
  status: 'success' | 'cancel' | 'error'

  @Prop({ required: true })
  encodedData: string

  @Prop({ required: true })
  apiPathBase: string

  @Prop({ required: true })
  encodedQueries: string

  viewModel: ViewModel | null = null

  // 形式の詳細は知る必要がないのでany
  get postData(): any {
    return JSON.parse(this.encodedData)
  }

  async created() {
    switch (this.status) {
      case 'success':
        return await this.setupViewModelForSuccess()
      case 'error':
        return await this.setupViewModelForError()
      case 'cancel':
        return await this.setupViewModelForCancel()
      default:
        log.error(`Unexpected status ${this.status}`)
        this.viewModel = this.fallbackViewModel
    }
  }

  async setupViewModelForSuccess() {
    if (!this.userIsRegistered) {
      // 決済は成功したと思われるがログインしていないブラウザで表示されたケース
      log.debug('Need login to show order complete page.')
      this.viewModel = ViewModelBuilder.forPaymentSuccessfullyDone()
        .addCheckOrderHistoryErrorMessage()
        .withCheckOrderHistoryAlertSection()
        .buildWithOrderHistoryViaLoginLink()

      return
    }

    (await interaction.callValidateApi(this.apiPathBase, this.encodedQueries, this.postData)).fold(
      (l: Error) => {
        log.error({ error: l })
        this.viewModel = this.fallbackViewModel
      },
      (r: ValidateApiResponse) => {
        this.viewModel = interaction.convertValidateApiResponseToViewModel(r)
      }
    )
  }

  async setupViewModelForError() {
    const builder = ViewModelBuilder.forPaymentError()
      .addGuideToReorderErrorMessage()
      .withReorderAlertSection()
    this.viewModel = this.userIsRegistered ?
      builder.buildWithReorderLink() :
      builder.buildWithReorderViaLoginLink()
  }

  async setupViewModelForCancel() {
    const builder = ViewModelBuilder.forPaymentCanceled()
      .withReorderAlertSectionOnCancel()
    this.viewModel = this.userIsRegistered ?
      builder.buildWithReorderLink() :
      builder.buildWithReorderViaLoginLink()
  }

  private get userIsRegistered(): boolean {
    return CookieService.isRegistered()
  }

  /**
   * 予期しないエラーが起こった際に表示する内容
   */
  private get fallbackViewModel(): ViewModel {
    return ViewModelBuilder.forUnexpectedError()
      .addMaybeErrorErrorMessage()
      .buildWithOrderHistoryLink()
  }
}
